//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.DeleteInspectionReportMutation
import com.wintermar.inspection.graphql.type.adapter.DeleteInspectionReportCommandInput_InputAdapter
import kotlin.Boolean
import kotlin.Suppress

public object DeleteInspectionReportMutation_VariablesAdapter {
  @Suppress(
    "UNUSED_PARAMETER",
    "UNUSED_VARIABLE",
  )
  public fun serializeVariables(
    writer: JsonWriter,
    `value`: DeleteInspectionReportMutation,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    writer.name("deleteInspectionReportCommandInput")
    DeleteInspectionReportCommandInput_InputAdapter.obj().toJson(writer, customScalarAdapters, value.deleteInspectionReportCommandInput)
  }
}
